import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { isNull } from "lodash"

import BasicButton from "@/components/button/BasicButton"
import Icon from "@/components/icon/Icon"
import SessionTypeTable from "@/app/settings/analysis-groups/sessions/SessionTypeTable"
import AddSessionTypeDialog from "@/app/settings/analysis-groups/sessions/AddSessionTypeDialog"
import { useSessionTypeQuery } from "@/hooks/api/useTeamQuery"
import { SessionType as TypeOfSessionType } from "@/types/session"

export default function SessionType() {
  const { t } = useTranslation()
  const [newSessionTypes, setNewSessionTypes] = useState<TypeOfSessionType[]>([])
  const [selectedIdfSessionType, setSelectedIdfSessionType] = useState<number | null>(null)
  const [sessionTypeTitle, setSessionTypeTitle] = useState<string>("")
  const [openDialog, setOpenDialog] = useState(false)

  const { data } = useSessionTypeQuery()

  useEffect(() => {
    setNewSessionTypes(data ?? [])
  }, [data])

  useEffect(() => {
    if (isNull(selectedIdfSessionType)) {
      setSessionTypeTitle("")
    } else {
      setSessionTypeTitle(
        newSessionTypes.find((sessionType) => sessionType.idfSessionType === selectedIdfSessionType)
          ?.name || "",
      )
    }
  }, [selectedIdfSessionType])

  const onCloseDialog = () => {
    setOpenDialog(false)
    setSelectedIdfSessionType(null)
  }

  return (
    <div className="SessionTypeCont">
      <div className="SessionTypeBtnCont">
        <h3>{t("sessions")}</h3>
        <BasicButton type="default-outlined" size="md" onClick={() => setOpenDialog(true)}>
          <span className="new-session-type-btn">
            <Icon type="add" size={16} /> <p>{t("button.newSessionType")}</p>
          </span>
        </BasicButton>
      </div>
      <SessionTypeTable
        data={newSessionTypes}
        setOpenEditDialog={setOpenDialog}
        selectedIdfSessionType={selectedIdfSessionType}
        setSelectedIdfSessionType={setSelectedIdfSessionType}
      />
      <AddSessionTypeDialog
        openDialog={openDialog}
        onCloseDialog={onCloseDialog}
        selectedIdfSessionType={selectedIdfSessionType}
        sessionTypeTitle={sessionTypeTitle}
      />
    </div>
  )
}
